// extracted by mini-css-extract-plugin
export default {"section":"section_section__4JzAU","hero":"section_hero__95Z2s","footer":"section_footer__20Eto"};